<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="批量编辑"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap" v-loading="dataLoading">
            <div class="tac text-color-error mb10">仅覆盖发生变动的内容，未填写的不覆盖</div>
            <el-form ref="form" :model="formItem" :rules="rules" label-width="150px">
                <el-form-item label="kpi维度（场景）：">
                    <div>
                        <span>{{deliverySceneText}}</span>
                    </div>
                </el-form-item>
                <el-form-item label="游戏分类：">
                    <div>
                        <span v-if="modalData[0]">{{modalData[0].game_classify}}</span>
                        <!--<span class="text-color-gray ml20 pointer font12px" @click="toAppPage">分类有问题？点击去更新</span>-->
                    </div>
                </el-form-item>
                <el-form-item label="分包类型：">
                    <el-select v-model="formItem.subpackage_type" clearable placeholder="请选择分包类型" style="width: 300px;">
                        <el-option label="分包" value="1"></el-option>
                        <el-option label="联运包" value="2"></el-option>
                        <el-option label="官包" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="每日预算：" prop="budget">
                    <el-input v-model="formItem.budget" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">元</span>
                </el-form-item>

                <template v-if="isIAP">
                    <el-form-item label="注册成本：" prop="register_price">
                        <el-input v-model="formItem.register_price" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">元</span>
                    </el-form-item>
                    <el-form-item label="新增付费成本：" prop="new_cost_price">
                        <el-input v-model="formItem.new_cost_price" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">元</span>
                    </el-form-item>
                    <el-form-item label="新增付费率：" prop="new_cost_rate">
                        <el-input v-model="formItem.new_cost_rate" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">%</span>
                    </el-form-item>
                    <el-form-item label="首日内购ROI：" prop="pay_roi1">
                        <el-input v-model="formItem.pay_roi1" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">%</span>
                    </el-form-item>
                </template>
                <template v-else-if="isIAA">
                    <el-form-item label="激活成本：" prop="active_price">
                        <el-input v-model="formItem.active_price" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">元</span>
                    </el-form-item>
                    <el-form-item label="首日变现ROI：" prop="ad_monetization_roi_1">
                        <el-input v-model="formItem.ad_monetization_roi_1" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">%</span>
                    </el-form-item>
                </template>


                <el-form-item v-for="item in selectList" :prop="item.id" :key="item.id" :label="item.display_name+'：'">
                    <el-input v-model="formItem[item.id]" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">{{item.config.type=='percent'?'%':item.config.type=='price'?'元':''}}</span>
                </el-form-item>

            </el-form>
            <div class="tac">
                <el-button size="mini" type="primary" plain @click="addKpiField" class="action-btn mr20">增加KPI指标</el-button>
            </div>
        </div>
        <div slot="title">
            <p>
                <span class="font14px text-bold">批量编辑</span>
                <span class="text-color-gray ml10">已选{{appCnt}}个产品</span>
            </p>
        </div>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
        <KpiFieldModal ref="kpiFieldModal" :config="configData"  :select-list="selectList" @save="saveSelectList" />
    </el-dialog>
</template>

<script>
    import KpiFieldModal from './kpiFieldModal';
    import API from '@/api/dataCenter/appKpi.js';
    export default {
        name: "BatchKpiModal",
        components:{
            KpiFieldModal,
        },
        props:{
            modalData:Array,
            config:Array,
            platId:[String,Number],
        },

        data(){
            let validateNum = (rule, value, callback) => {
                if (value===0||value==='0'||parseFloat(''+value)===0) {
                    return callback(new Error('不能设置为0'));
                }
                if(!value){
                    callback();
                }else if (isNaN(value)) {
                    return callback(new Error('请输入数值'));
                } else if(Number.isInteger(value)) {
                    callback();
                }else if((value+'').includes('.')){
                    let num = (value+'').split('.')[1].length;
                    if (num > 2) {
                        return callback(new Error('小数点不能超过2位'));
                    } else {
                        callback();
                    }
                }else{
                    callback();
                }
            };

            return {
                dialogVisible:false,
                submitLoading:false,
                dataLoading:false,
                formItem:{
                    subpackage_type:'',
                    budget:'',
                    register_price:'',
                    new_cost_price:'',
                    new_cost_rate:'',
                    pay_roi1:'',
                    active_price:'',
                    ad_monetization_roi_1:'',
                },
                selectList:[],
                rules:{
                    budget:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    register_price:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    new_cost_price:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    new_cost_rate:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    pay_roi1:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    cli_price:[{ validator: validateNum, trigger: 'blur' },],
                    download_price:[{ validator: validateNum, trigger: 'blur' },],
                    active_price:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention1_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention3_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention7_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention14_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention30_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_roi3:[{ validator: validateNum, trigger: 'blur' },],
                    pay_roi7:[{ validator: validateNum, trigger: 'blur' },],
                    pay_roi30:[{ validator: validateNum, trigger: 'blur' },],
                    pay_roi:[{ validator: validateNum, trigger: 'blur' },],
                    pay_ltv1:[{ validator: validateNum, trigger: 'blur' },],
                    pay_ltv3:[{ validator: validateNum, trigger: 'blur' },],
                    pay_ltv7:[{ validator: validateNum, trigger: 'blur' },],
                    pay_ltv30:[{ validator: validateNum, trigger: 'blur' },],
                    week_pay_roi:[{ validator: validateNum, trigger: 'blur' },],
                    month_pay_roi:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi1:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi3:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi7:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi30:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi:[{ validator: validateNum, trigger: 'blur' },],
                    ad_monetization_roi_1:[{ validator: validateNum, trigger: 'blur' },],
                }
            }
        },
        computed:{
            configData(){
                return this.config.map(item=>{
                    let group = {};
                    group.checked = false;
                    group.indeterminate = false;
                    group.config = JSON.parse(item.config||'{}');
                    group.display_name = item.display_name;
                    group.id = item.id;
                    group.pid = item.pid;
                    group.disabled = this.requiredList.includes(item.id);
                    let children = item.children||[];
                    let selectList = this.selectList.map(item=>item.id);
                    if(children.length>0){
                        group.children = children.map(inner=>{
                            return {
                                checked:this.requiredList.concat(selectList).includes(inner.id),
                                config:JSON.parse(inner.config||'{}'),
                                disabled:this.requiredList.includes(inner.id),
                                display_name:inner.display_name,
                                id:inner.id,
                                pid:inner.pid,
                            };
                        })
                    }
                    return group;
                })
            },
            allFields(){
                let list = [];
                this.configData.forEach(item=>{
                    list = list.concat(item.children||[]);
                });
                return list;
            },
            appCnt(){
                let appArr = this.modalData.map(item=>item.app_id);
                return [...new Set(appArr)].length;
            },
            deliverySceneText(){
                let allTextArr = ['整体','商店-整体','非商店-整体','信息流','联盟','智能投放'];
                let sceneTextArr = (this.modalData||[]).map(item=>item.delivery_scene_text);
                return allTextArr.filter(item=>sceneTextArr.includes(item)).join('，');
            },
            requiredList(){
                if(this.isIAA){
                    return [
                        'delivery_scene',
                        'budget',
                        'subpackage_type',
                        'ad_monetization_roi_1',
                        'active_price',
                    ];
                }
                return [
                    'delivery_scene',
                    'subpackage_type',
                    'budget',
                    'register_price',
                    'new_cost_price',
                    'new_cost_rate',
                    'pay_roi1',
                ];
            },
            isIAA(){
                return this.modalData.every(item=>item.game_classify=='iaa'||item.game_classify=='IAA');
            },
            isIAP(){
                return this.modalData.every(item=>item.game_classify=='iap'||item.game_classify=='IAP');
            },
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm() {
                this.selectList = [];
                this.formItem = {
                    delivery_scene:'',
                    subpackage_type:'',
                    budget:'',
                    register_price:'',
                    new_cost_price:'',
                    new_cost_rate:'',
                    pay_roi1:'',
                };
                this.$refs.form.clearValidate();
            },
            showModal(){
                this.dialogVisible = true;
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let allList = this.requiredList.concat(this.selectList.map(item=>item.id));
                        let saveList = allList.filter(item=>{
                            return !!this.formItem[item];
                        });
                        if(saveList.length<=0){
                            return this.$message.error('未修改任何内容，若不需保存请点击取消');
                        }
                        let itemStr = '';
                        saveList.forEach(item=>{
                            let actionItem = this.allFields.find(inner=>inner.id==item);
                            let config = actionItem.config||{};
                            let typeStr = config.type == 'price'?'元':config.type == 'percent'?'%':'';
                            let valStr = '';
                            if(item=='subpackage_type'){
                                valStr = this.formItem[item]=='1'?'分包':this.formItem[item]=='2'?'联运包':this.formItem[item]=='3'?'官包':'-';
                            }else{
                                valStr = this.formItem[item]+typeStr;
                            }

                            itemStr = itemStr + `<p class="font12px"><span class="text-bold">${actionItem.display_name}：</span>${valStr}</p>`;
                        });
                        let htmlStr = `<div class="text-color-error mb10 tal">保存后将覆盖勾选产品的以下内容，确认要覆盖吗？</div><div class="tal" style="max-height: 200px;overflow: auto;">${itemStr}</div>`;

                        this.$confirm(htmlStr, '覆盖提醒', {
                            confirmButtonText: '覆盖',
                            cancelButtonText: '取消',
                            type: 'warning',
                            center: true,
                            showClose: false,
                            dangerouslyUseHTMLString: true,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            cancelButtonClass:'mr10',
                            confirmButtonClass:'ml10',
                        }).then(()=>{
                            this.submitLoading = true;
                            let reqData = {
                                plat_id:this.platId,
                            };
                            reqData.data = (this.modalData||[]).map(item=>{
                                return {
                                    app_id:item.app_id,
                                    delivery_type:item.delivery_type,
                                    delivery_scene:item.delivery_scene,
                                }
                            });

                            /* 过滤一下formItem里不需要的值 */
                            let selectListItem = this.selectList.map(item=>item.id);
                            let allFormList = [].concat(this.requiredList,selectListItem);
                            let formData = {};
                            Object.keys(this.formItem).forEach(item=>{
                                if(allFormList.includes(item)){
                                    formData[item] = this.formItem[item];
                                }
                            });
                            
                            API.batchEditAppKpi(Object.assign({},formData,reqData)).then(res=>{
                                this.submitLoading = false;
                                this.$message.success(res.info||'操作成功');
                                this.$emit('update');

                                this.dialogVisible = false;
                                this.resetForm();

                            },err=>{
                                console.log('editAppKpi err',err);
                                this.submitLoading = false;
                                this.$message.error(err.info||'操作失败');
                            })

                        }).catch(()=>{
                            console.log('取消');
                        });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            addKpiField(){
                this.$refs.kpiFieldModal.showModal();
            },
            saveSelectList(list){
                this.selectList = list.map(item=>item);
                let formList = Object.keys(this.formItem);
                if(list.length<=0){
                    formList.forEach(item=>{
                        if(!this.requiredList.includes(item)){
                            delete this.formItem[item];
                        }
                    })
                }else{
                    list.forEach(item=>{
                        if(!formList.includes(item.id)){
                            this.$set(this.formItem,item.id,'');
                        }
                    });
                }
            },
            validateNum(rule, value, callback){
                if (value===0) {
                    return callback(new Error('不能设置为0'));
                }
                if(!value){
                    callback();
                }else if (isNaN(value)) {
                    return callback(new Error('请输入数值'));
                } else if(Number.isInteger(value)) {
                    callback();
                }else if((value+'').includes('.')){
                    let num = (value+'').split('.')[1].length;
                    if (num > 2) {
                        return callback(new Error('小数点不能超过2位'));
                    } else {
                        callback();
                    }
                }
            },
        }

    }
</script>

<style lang="scss" scoped>
.content-wrap{
    max-height: 400px;
    overflow-y: auto;

    ::v-deep .el-input-number__decrease,::v-deep .el-input-number__increase{
        display: none;
    }
}
</style>
